import React, { useEffect, useState } from "react";
import AdminCorrectionForm from "./AdminCorrectionForm";
import { getPatientForCorrection } from "../lib/demographic"; // NOTE: confirm this path against the real filename — see import-path flag

/**
 * AdminCorrectionFormContainer
 *
 * AdminCorrectionForm explicitly does not do its own patient lookup —
 * it expects initialValues as a prop. This wraps it with the fetch
 * against GET /api/v1/demographics/patient/:patientId, so call sites
 * that currently render <AdminCorrectionForm patientId={...} /> can
 * swap in this container with no other changes.
 *
 * Field names returned by the route (first_name, last_name,
 * date_of_birth, sex, external_mrn) match AdminCorrectionForm's
 * initialValues shape 1:1 — no mapping needed.
 */
export default function AdminCorrectionFormContainer({
  patientId,
  onBack,
  onResolved,
}) {
  const [initialValues, setInitialValues] = useState(null);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setInitialValues(null);
    setLoadError(null);

    getPatientForCorrection(patientId)
      .then((data) => {
        if (!cancelled) setInitialValues(data);
      })
      .catch((err) => {
        if (!cancelled) {
          setLoadError(
            err.response?.data?.message || "Failed to load patient record",
          );
        }
      });

    return () => {
      cancelled = true;
    };
  }, [patientId]);

  if (loadError) {
    return (
      <div className="space-y-4">
        <button
          onClick={onBack}
          className="text-sm text-blue-600 hover:text-blue-800 transition-colors"
        >
          ← Back
        </button>
        <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
          {loadError}
        </p>
      </div>
    );
  }

  if (!initialValues) {
    return (
      <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <p className="text-sm text-gray-500">Loading patient record…</p>
      </div>
    );
  }

  return (
    <AdminCorrectionForm
      patientId={patientId}
      initialValues={initialValues}
      onBack={onBack}
      onResolved={onResolved}
    />
  );
}